import React, { createContext, useState, useContext } from "react";

// Tạo Context
const RegionContext = createContext();

// Tạo Provider để bọc ứng dụng
export const RegionProvider = ({ children }) => {
    const [selectedRegion, setSelectedRegion] = useState(null);

    // Hàm cập nhật vùng
    const handleSelectRegion = (region) => {
        setSelectedRegion(region);
    };

    return (
        <RegionContext.Provider value={{ selectedRegion, handleSelectRegion }}>
            {children}
        </RegionContext.Provider>
    );
};

// Custom Hook để dễ dàng sử dụng Context
export const useRegion = () => {
    return useContext(RegionContext);
};

